import {createAsyncThunk} from '@reduxjs/toolkit'
import { getBusinessType } from 'sr/utils/api/masterData/businesstype/getBusinessType'
export const fetchBusinessType = createAsyncThunk(
  'business/fetchBusinessType',
  async () => {
    const response = await getBusinessType()
    return response?.data
  }
)
